import { render, staticRenderFns } from "./CampaignTokenGate.vue?vue&type=template&id=4132826d&scoped=true&"
import script from "./CampaignTokenGate.vue?vue&type=script&lang=ts&"
export * from "./CampaignTokenGate.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignTokenGate.vue?vue&type=style&index=0&id=4132826d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132826d",
  null
  
)

export default component.exports